export const RELATIONSHIP_TYPES = {
    SELF: {
        value: 'SELF',
        key: 'self'
    },
    SPOUSE: {
        value: 'SPOUSE',
        key: 'spouse'
    },
    FATHERORMOTHER: {
        value: 'FATHER OR MOTHER',
        key: 'fatherOrMother'
    },
    GRANDFATHERORGRANDMOTHER: {
        value: 'GRANDFATHER OR GRANDMOTHER',
        key: 'grandfatherOrGrandmother'
    },
    GRANDSONORGRANDAUGHTER: {
        value: 'GRANDSON OR GRANDDAUGHTER',
        key: 'grandsonOrGrandaughter'
    },
    UNCLEORAUNT: {
        value: 'UNCLE OR AUNT',
        key: 'uncleOrAunt'
    },
    NEPHEWORNIECE: {
        value: 'NEPHEW OR NIECE',
        key: 'nephewOrNiece'
    },
    COUSIN: {
        value: 'COUSIN',
        key: 'cousin'
    },
    ADOPTEDCHILD: {
        value: 'ADOPTED CHILD',
        key: 'adoptedChild'
    },
    FOSTERCHILD: {
        value: 'FOSTER CHILD',
        key: 'fosterChild'
    },
    SONORDAUGHTERLAW: {
        value: 'SON-IN-LAW OR DAUGHTER-IN-LAW',
        key: 'sonOrDaughterLaw'
    },
    BROTHERORSISTERLAW: {
        value: 'BROTHER-IN-LAW OR SISTER-IN-LAW',
        key: 'brotherOrSisterLaw'
    },
    MOTHERORFATHERLAW: {
        value: 'MOTHER-IN-LAW OR FATHER-IN-LAW',
        key: 'motherOrFatherLaw'
    },
    BROTHERORSISTER: {
        value: 'BROTHER OR SISTER',
        key: 'brotherOrSister'
    },
    WARD: {
        value: 'WARD',
        key: 'ward'
    },
    STEPPARENT: {
        value: 'STEPPARENT',
        key: 'stepparent'
    },
    STEPSONORDAUGHTER: {
        value: 'STEPSON OR STEPDAUGHTER',
        key: 'stepSonOrDaughter'
    },
    CHILD: {
        value: 'CHILD',
        key: 'child'
    },
    SPONSOREDDEPENDENT: {
        value: 'SPONSORED DEPENDENT',
        key: 'sponsoredDependent'
    },
    DEPENDENTMINORDEPENDENT: {
        value: 'DEPENDENT OF A MINOR DEPENDENT',
        key: 'dependentMinorDependent'
    },
    EXSPOUSE: {
        value: 'EX-SPOUSE',
        key: 'exSpouse'
    },
    GUARDIAN: {
        value: 'GUARDIAN',
        key: 'guardian'
    },
    COURTAPPOINTEDGUARDIAN: {
        value: 'COURT APPOINTED GUARDIAN',
        key: 'courtAppointedGuardian'
    },
    COLLATERALDEPENDENT: {
        value: 'COLLATERAL DEPENDENT',
        key: 'collateralDependent'
    },
    LIFEPARTNER: {
        value: 'LIFE PARTNER',
        key: 'lifePartner'
    },
    ANNUITANT: {
        value: 'ANNUITANT',
        key: 'annuitant'
    },
    TRUSTEE: {
        value: 'TRUSTEE',
        key: 'trustee'
    },
    OTHERRELATIONSHIP: {
        value: 'OTHER RELATIONSHIP',
        key: 'otherRelationship'
    },
    OTHERRELATIVE: {
        value: 'OTHER RELATIVE',
        key: 'otherRelative'
    }
};